export const convertToKebabCase = (text: string) => {
  return text
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .toLowerCase()
}
